import endpoints from '../endpoints';
import StoreFromFile from './StoreFromFile';

class DeliveryOptionsStore extends StoreFromFile {
  constructor(name) {
    super(name);
    this.storeSavedName = 'XXDeliveryOptions';
    this.endpoint = endpoints.delivery_options.get;
  }
}

export default DeliveryOptionsStore;
